<div class="d-flex flex-column flex-lg-row flex-wrap types-container">
    <adapt-input-type *ngFor="let inputType of inputTypes; let last = last"
                      [inputType]="inputType"
                      [canvas]="canvas"
                      [ngClass]="{'w-100': last, 'half-column': !last}"></adapt-input-type>
</div>
